import { wdpUtil } from "../common/utils/util";

export default class ApiControllerService {

  // abortControllers[rowIndex][field] = AbortController
  private static abortControllers: Array<{
    fireNumber?: AbortController | null,
    internalOrder?: AbortController | null,
    costCenter?: AbortController | null
  }> = [];

  // Ensure row exists
  static ensureRow(rowIndex: number) {
    if (!this.abortControllers[rowIndex]) {
      this.abortControllers[rowIndex] = {
        fireNumber: null,
        internalOrder: null,
        costCenter: null
      };
    }
  }

  // Abort previous request for a specific field
  static abortPrevious(rowIndex: number, field: "fireNumber" | "internalOrder" | "costCenter") {
    this.ensureRow(rowIndex);

    const prev = this.abortControllers[rowIndex][field];
    if (prev) prev.abort();
  }

  // Create + store a new controller for a specific field
  static createController(rowIndex: number, field: "fireNumber" | "internalOrder" | "costCenter") {
    this.ensureRow(rowIndex);

    // Abort previous before creating new
    this.abortPrevious(rowIndex, field);

    const controller = new AbortController();
    this.abortControllers[rowIndex][field] = controller;

    return controller;
  }

  // Optional: clear all controllers (e.g., on form reset)
  static resetAll() {
    this.abortControllers.forEach(row => {
      if (!row) return;
      Object.values(row).forEach(ctrl => ctrl?.abort());
    });
    this.abortControllers = [];
  }
}
